export default "__VITE_ASSET__BZL$4vf8__"